import React from "react";

/**
 * Petite pastille « Nouveau » / « Mis à jour » affichée à côté du titre d'un article.
 * `recency` provient de recencyOf() (docDates.js) : 'new' | 'updated' | null.
 */
const RecencyBadge = ({ recency, t }) => {
  if (!recency) return null;
  const isNew = recency === "new";
  return (
    <span className={`doc-badge ${isNew ? "doc-badge-new" : "doc-badge-updated"}`}>
      {t(isNew ? "helpCenter.badge.new" : "helpCenter.badge.updated")}
    </span>
  );
};

export default RecencyBadge;
